<ion-grid>
  <div class="margin-bot-40" *ngIf="showMessage">
    <app-download-message [state]="state" (exit)="closeMessage()">
    </app-download-message>
  </div>
  <ion-row style="flex-wrap: wrap; justify-content: space-between; align-items: center;">
    <div>
      <span class="text-secondary font-size-20"
        >Suscripción {{ subscriptionIndex + 1 }}</span
      >
      <span [ngClass]="labelSubscriptionClass()">{{ activeLabel }}</span>
    </div>

    <span class="modify-label-container" *ngIf="isSubscriptionActive">
      <ion-button
        class="modify-button"
        [class.focused-ion-button]="isButtonFocused"
        (ionFocus)="onFocus()"
        (ionBlur)="onBlur()"
        (click)="openModificationModal()"
        (keypress)="true"
        >Modificar</ion-button>
      <ion-button
        class="modify-button"
        [class.focused-ion-button]="isButtonFocusedRevocar"
        (ionFocus)="onFocusRevocar()"
        (ionBlur)="onBlurRevocar()"
        (click)="openStopSubscriptioModal()"
        (keypress)="true"
        >Revocar</ion-button>
    </span>
  </ion-row>
  <ion-row class="row-container-subscription">
    <ion-col size="12" size-xl="auto">
      <div class="first-column">
        <ion-row class="margin-row"> </ion-row>
        <ion-row class="employer-block d-flex flex-column">
          <div class="font-size-20 font-weight-700 mb-4 col-text-align">
            {{ subscriptionData.employerName }}
          </div>
          <div class="font-size-14 col-text-align">
            Aporte desde tu sueldo, vía empleador
          </div>
        </ion-row>
        <ion-row class="d-flex flex-column">
          <div class="font-size-14">Ahorro mensual</div>
          <div>
            <span class="apv-title font-weight-700">{{ formattedAmount }}</span>
          </div>
        </ion-row>
        <div class="link-block" *ngIf="isSubscriptionActive">
          <ion-button
            class="hiperlink-button"
            fill="clear"
            (click)="descargarComprobanteSuscripcion('comprobante_')"
            (keypress)="true"
          >
            <p
              *ngIf="!isMobile"
              class="hiperlink-text text-tertiary cursor-pointer text-underline"
            >
              Descargar comprobante de suscripción
            </p>
          </ion-button>
          <!--ngIF-->
        </div>
        <div class="link-block" *ngIf="!isSubscriptionActive">
          <p class="font-size-14">Fecha de revocación: {{ revokedDate }}</p>
          <ion-button
            class="hiperlink-button"
            fill="clear"
            (click)="descargarComprobanteSuscripcion('Comprobante_revocacion_')"
            (keypress)="true"
          >
            <p
              *ngIf="!isMobile"
              class="hiperlink-text text-tertiary cursor-pointer text-underline"
            >
              Descargar comprobante de revocación
            </p>
          </ion-button>
        </div>
      </div>
    </ion-col>

    <ion-col size="12" size-xl="auto">
      <div class="second-column">
        <ion-row class="mb-12 d-flex flex-column second-column-margin">
          <div class="detail-label">{{ savingSince }}</div>
          <div class="detail-value text-light-black">{{ savingSinceDate }}</div>
        </ion-row>
        <ion-row class="mb-12 d-flex flex-column">
          <div class="detail-label">Régimen tributario</div>
          <div class="detail-value text-light-black">
            {{ subscriptionData.taxRegimeCode }}
          </div>
        </ion-row>
        <ion-row class="mb-12 d-flex flex-column">
          <div class="detail-label">Último depósito</div>
          <div
            class="detail-value text-light-black"
            *ngIf="showLastPaymentDateSkeleton"
          >
            <ion-skeleton-text
              animated
              style="width: 50%; height: 10px"
            ></ion-skeleton-text>
          </div>
          <div
            class="detail-value text-light-black"
            *ngIf="!showLastPaymentDateSkeleton"
          >
            {{ lastPaymentDate }}
          </div>
        </ion-row>
        <ion-row *ngIf="isSubscriptionActive" class="mb-12 d-flex flex-column">
          <div class="detail-label">Vigencia</div>
          <div class="detail-value text-light-black">Indefinida</div>
        </ion-row>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
